import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getScheduleCommentaryAuthorNotes = api(async function getScheduleCommentaryAuthorNotes({
    projectId,
    scheduleId,
}) {
    if (!projectId || !scheduleId) return null

    return query(
        gql`
            query GetScheduleCommentaryAuthorNotes($projectId: String!, $scheduleId: String!) {
                getScheduleCommentaryAuthorNotes(projectId: $projectId, scheduleId: $scheduleId) {
                    title
                    code
                    version
                    leadingSummary {
                        amendsKey
                        label
                        content
                        hasAmends
                    }
                    introContent {
                        amendsKey
                        label
                        content
                        hasAmends
                    }
                    introNote {
                        amendsKey
                        label
                        content
                        hasAmends
                    }
                    tasks {
                        amendsKey
                        label
                        content
                        hasAmends
                    }
                    legislation {
                        scheduleLegislationId
                        html
                        url
                    }
                }
            }
        `,
        { projectId, scheduleId },
        { returns: "getScheduleCommentaryAuthorNotes" }
    )
})
